import React from 'react';

const ButtonOther = ({
  classes,
  icon,
  label = '',
  ariaLabel = '',
  onClick,
}) => {
  const buttonJSX = (
    <>
      <span>
        <b className="text-base font-crystalCondensed">{label}</b>
      </span>
      {icon}
    </>
  );

  return (
    <button
      onClick={onClick}
      className={classes}
      aria-label={ariaLabel}
      type="button"
    >
      {buttonJSX}
    </button>
  );
};

export default ButtonOther;
